import React from 'react';
import toast, { Toaster } from 'react-hot-toast';

import {confirmAlert} from "react-confirm-alert";
import Role from "../../../inc/Role";
import {NavLink, useNavigate} from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import {Config} from '../../../Config'
import moment from "moment-timezone";
import * as Utils from "../../../inc/Utils";
import Select from 'react-select'
import DatePicker from "react-datepicker";

export default function CampaignTemplateCreateSpecial(props) {
    const roles = new Role();
    let userId = roles.loginUserId;

    let btnTextDefault = 'บันทึกข้อมูล';
    let btnTextLoading = 'กำลังบันทึก..';
    let [isLoading, setLoading] = React.useState(false); 
    const navigate = useNavigate();

    let [typeId, setTypeId] = React.useState(null);
    let [lang, setLang] = React.useState(null);
    let [langId, setLangId] = React.useState(null);
    let [projectType, setProjectType] = React.useState(null);
    let [projectTypeId, setProjectTypeId] = React.useState(null);

    let [campaign, setCampaign] = React.useState(null);
    let [campaignId, setCampaignId] = React.useState(null);
    let [campaignPlaceholder, setCampaignPlaceholder] = React.useState('...');
    let [disableCampaign, setDisableCampaign] = React.useState(true);

    let [isCustomUrl, setIsCustomUrl] = React.useState(false);

    let [specialFilterId, setSpecialFilterId] = React.useState(null);
    let [specialFilter, setSpecialFilter] = React.useState(null);
    let [zoneStatus, setZoneStatus] = React.useState(null);
    let [zoneStatusId, setZoneStatusId] = React.useState(null);
    let [eventDate, setEventDate] = React.useState(null);

    let [bgZoneId, setBgZoneId] = React.useState(null);
    let [bgZone, setBgZone] = React.useState(null);
    let [bgZonePlaceholder, setBgZonePlaceholder] = React.useState('Select...');

    let [combineZoneId, setCombineZoneId] = React.useState(null);
    let [combineZone, setCombineZone] = React.useState(null);
    let [combineZonePlaceholder, setCombineZonePlaceholder] = React.useState('Select...');

    let [eventReminderId, setEventReminderId] = React.useState(null);
    let [eventReminder, setEventReminder] = React.useState(null);
    let [eventReminderPlaceholder, setEventReminderPlaceholder] = React.useState('Select...');

    let [staticPageId, setStaticPageId] = React.useState(null);
    let [staticPage, setStaticPage] = React.useState(null);
    let [staticPagePlaceholder, setStaticPagePlaceholder] = React.useState('Select...');
    let [agency, setAgency] = React.useState(null);

    let refUrl = React.useRef();
    let refSlug = React.useRef();

    React.useEffect(() => {
        setTypeId(props.typeId);

        (async function() {
            try {
                const resAgency = await Utils.getAgency();
                setAgency(resAgency);

                const resLanguage = await Utils.getLanguage();
                setLang(resLanguage);

                const resFilter = await Utils.getAdsNamingSpecialFilter();
                setSpecialFilter(resFilter);
                const resZoneStatus = await Utils.getAdsNamingZoneStatus();
                setZoneStatus(resZoneStatus);
                const resProjectType = await Utils.getProjectType();
                setProjectType(resProjectType);

                setCampaignPlaceholder('กำลังโหลด...');
                setDisableCampaign(true);
                const resCampaign = await Utils.getListSubCampaign();
                if(resCampaign) {
                    let campaignList = resCampaign.campaign;
                    if(campaignList) {
                        let newCampaign = [];
                        for(let rs of campaignList) {
                            newCampaign.push({
                                campaign_id: rs.sub_campaign_id,
                                campaign_name: rs.sub_campaign_name
                            })
                        }
                        setCampaign(newCampaign);
                        setCampaignPlaceholder('Select...');
                        setDisableCampaign(false);
                    }
                }
                else {
                    setCampaign(null);
                    setCampaignPlaceholder('ไม่พบข้อมูล..');
                }

            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    const onCreate = () => {
        let name = props.name;
        let url = refUrl.current.value;
        let slug = refSlug.current.value;

        let items = [];
        if(roles.permissionId === Utils.SUPER_ADMIN_ID) {
            let checkboxes = document.getElementsByName('agencyIds[]');
            for (let i = 0; i < checkboxes.length; i++) {
                if(checkboxes[i].checked) {
                    items.push({'agencyId': checkboxes[i].value});
                }
            }
        }
        else {
            items.push({'agencyId': roles.agencyId});
        }

        if(!name) {
            toast.error("กรุณาระบุ ชื่อ Campaign Template");
        }
        else if(!typeId) {
            toast.error("กรุณาระบุ Type");
        }
        else if(!campaignId) {
            toast.error("กรุณาระบุ Campaign ID");
        }
        else if(!url) {
            toast.error("กรุณาระบุ URL");
        }
        else if(!isCustomUrl && !langId) {
            toast.error("กรุณาระบุ Language");
        }
        else if(!isCustomUrl && !specialFilterId) {
            toast.error("กรุณาระบุ Filter Type");
        }
        else if(!isCustomUrl && specialFilterId && specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_BG_ZONE && !projectTypeId) {
            toast.error("กรุณาระบุ Zone Project");
        }
        else if(!isCustomUrl && specialFilterId && specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_BG_ZONE && !zoneStatusId) {
            toast.error("กรุณาระบุ Zone Status");
        }
        else if(!isCustomUrl && specialFilterId && specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_BG_ZONE && !bgZoneId) {
            toast.error("กรุณาระบุ BG Zone");
        }
        else if(!isCustomUrl && specialFilterId && specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_COMBINE_ZONE && !zoneStatusId) {
            toast.error("กรุณาระบุ Zone Status");
        }
        else if(!isCustomUrl && specialFilterId && specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_COMBINE_ZONE && !combineZoneId) {
            toast.error("กรุณาระบุ Combine Zone");
        }
        else if(!isCustomUrl && specialFilterId && specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_EVENT_REMINDER && !eventDate) {
            toast.error("กรุณาระบุ Event Date");
        }
        else if(!isCustomUrl && specialFilterId && specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_EVENT_REMINDER && !eventReminderId) {
            toast.error("กรุณาระบุ Event Reminder");
        }
        else if(!isCustomUrl && specialFilterId && specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_STATIC_PAGE && !staticPageId) {
            toast.error("กรุณาระบุ Static Page");
        }
        else if(!isCustomUrl && slug === '') {
            toast.error("กรุณาระบุ Slug");
        }
        else if(items.length <= 0) {
            toast.error("กรุณาระบุ Agency อย่างน้อย 1 รายการ");
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: () => {
                            setLoading(true);

                            let statusChecked = document.getElementsByName('statusChecked');

                            const body = {
                                items: items,
                                name: name,
                                typeId: typeId ? typeId.id : null,
                                lang: langId ? langId.id : null,
                                projectTypeId: projectTypeId ? projectTypeId.id : null,
                                campaignId: campaignId ? campaignId.campaign_id : null,
                                specialFilterId: specialFilterId ? specialFilterId.id:null,
                                zoneStatus: zoneStatusId ? zoneStatusId.id:null,
                                eventDate: eventDate ? new Date(eventDate) : null,
                                webPage: null,
                                isCustomUrl: isCustomUrl ? 1:null,
                                slug: slug ?? null,
                                url: url,
                                status: statusChecked[0].checked ? 1:0,
                                createdBy: userId,
                                createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                            };
                                fetch(Config.url.API_URL +'/api/campaignTemplate/create', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(response => {
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success("บันทึกข้อมูลเรียบร้อย");
                                    setTimeout(function () {
                                        navigate('/campaignTemplate', {replace: true});
                                    }, 1500);
                                }
                                else {
                                    setLoading(false);
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    const onChangeLanguageId = async (obj) => {
        setLangId(obj);
        setSpecialFilterId(null);
        setProjectTypeId(null);
        setZoneStatusId(null);
        setBgZoneId(null);
        setCombineZoneId(null);
        setStaticPageId(null);
        setEventDate('');
    };

    const onChangeCampaignId = (obj) => {
        setCampaignId(obj);
    };

    const onChangeCustomUrl = (flag) => {
        setIsCustomUrl(flag);
        if(flag) {
            setLangId(null);
            setProjectTypeId(null);
            setSpecialFilterId(null);
            setZoneStatusId(null);
            setEventDate('');
            setBgZoneId(null);
        }
    };

    const onChangeFilterTypeId = async (obj) => {
        setSpecialFilterId(obj);
        setProjectTypeId(null);
        setZoneStatusId(null);
        refSlug.current.value = '';
        if(obj?.id === Utils.ADS_NAMING_SPECIAL_FILTER_STATIC_PAGE) {
            setStaticPagePlaceholder('กำลังโหลด...');
            const resEv = await Utils.getStaticPage({langId: langId.id});
            setStaticPagePlaceholder('เลือก..');
            if(resEv && resEv.data && resEv.data) {
                setStaticPage(resEv.data);
            }
            else {
                toast.error('ไม่พบข้อมูล Static Page');
            }
        }
    };

    const onChangeProjectTypeId = async (obj) => {
        setProjectTypeId(obj);
        setBgZone('');
        setZoneStatusId(null);
        setBgZoneId(null);
        setCombineZoneId(null);
        refSlug.current.value = '';
        if(obj && obj.id && zoneStatusId) {
            setBgZonePlaceholder('กำลังโหลด...');
            const resBGZone = await Utils.getBGZone({langId: langId.id, projectTypeId: obj.id, zoneStatusId: zoneStatusId.id});
            setBgZonePlaceholder('เลือก..');
            if(resBGZone && resBGZone.data && resBGZone.data.zones) {
                setBgZone(resBGZone.data.zones);
            }
            else {
                toast.error('ไม่พบข้อมูล BG Zone');
            }
        }
    };

    const onChangeZoneStatusId = async (obj) => {
        setZoneStatusId(obj);
        setBgZone('');
        setCombineZone('');
        setBgZoneId(null);
        setCombineZoneId(null);
        refSlug.current.value = '';
        if(obj && obj.id && projectTypeId && langId && specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_BG_ZONE) {
            setBgZonePlaceholder('กำลังโหลด...');
            const resBGZone = await Utils.getBGZone({langId: langId.id, projectTypeId: projectTypeId.id, zoneStatusId: obj.id});
            setBgZonePlaceholder('เลือก..');
            if(resBGZone && resBGZone.data && resBGZone.data.zones) {
                setBgZone(resBGZone.data.zones);
            }
            else {
                toast.error('ไม่พบข้อมูล BG Zone');
            }
        }
        else if(obj && obj.id && specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_COMBINE_ZONE) {
            setCombineZonePlaceholder('กำลังโหลด...');
            const resCombineZone = await Utils.getCombineZone({langId: langId.id, zoneStatusId: obj.id});
            setCombineZonePlaceholder('เลือก..');
            if(resCombineZone && resCombineZone.data && resCombineZone.data.zones) {
                setCombineZone(resCombineZone.data.zones);
            }
            else {
                toast.error('ไม่พบข้อมูล Combine Zone');
            }
        }
    };

    const onChangeEventDate = async (value) => {
        setEventDate(value);
        setEventReminderPlaceholder('กำลังโหลด...');
        const resEv = await Utils.getEventReminder({langId: langId.id, eventDate: value});
        setEventReminderPlaceholder('เลือก..');
        if(resEv && resEv.data && resEv.data) {
            setEventReminder(resEv.data);
        }
        else {
            toast.error('ไม่พบข้อมูล Event Reminder');
        }
    };

    const onChangeBGZoneId = async (obj) => {
        refSlug.current.value = obj.zone_slug ?? '';
        refUrl.current.value = obj.zone_url ?? '';
        setBgZoneId(obj);
    };

    const onChangeCombineZoneId = async (obj) => {
        refSlug.current.value = obj.zone_slug ?? '';
        refUrl.current.value = obj.zone_url ?? '';
        setCombineZoneId(obj);
    };

    const onChangeEventReminderId = async (obj) => {
        refSlug.current.value = obj.event_slug ?? '';
        refUrl.current.value = obj.event_url ?? '';
        setEventReminderId(obj);
    };

    const onChangeStaticPageId = async (obj) => {
        refSlug.current.value = obj.web_page ?? '';
        refUrl.current.value = obj.web_url ?? '';
        setStaticPageId(obj);
    };

    return (
        <>
            <div className="col-12">
                <label htmlFor="campaignId" className="form-label">Campaign ID <span className="text-danger">*</span></label>
                <Select
                    isDisabled={disableCampaign}
                    classNamePrefix="form-select-search"
                    placeholder={campaignPlaceholder}
                    options={campaign}
                    onChange={(event) => onChangeCampaignId(event)}
                    value={campaignId}
                    getOptionValue={(option) => `${option.campaign_id}`}
                    getOptionLabel={(option) => `${option.campaign_id} : ${option.campaign_name}`}
                />
            </div>
            <div className="col-12">
                <label htmlFor="url" className="form-label">URL <span className="text-danger">*</span></label>
                <textarea className="form-control" id="url" ref={refUrl} rows={5}></textarea>
            </div>

            <div className="col-12">
                <div className="row">
                    <div className="col-sm-6">
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="urlType"
                                   id="urlType1" checked={!isCustomUrl} onChange={e => onChangeCustomUrl(false)} />
                            <label className="form-check-label" htmlFor="urlType1">
                                AP Special
                            </label>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="urlType"
                                   id="urlType2" checked={isCustomUrl} onChange={e => onChangeCustomUrl(true)} />
                            <label className="form-check-label" htmlFor="urlType2">
                                Custom URL
                            </label>
                        </div>
                    </div>
                </div>
                <div className={"row g-3 border rounded bg-light p-2 mt-0 mb-3" + (isCustomUrl ? ' d-none':'')}>
                    <div className={"col-12 mt-1" + (isCustomUrl ? ' d-none':'')}>
                        <label htmlFor="langId" className="form-label">Language <span className="text-danger">*</span></label>
                        <Select
                            classNamePrefix="form-select-search"
                            options={lang}
                            onChange={(event) => onChangeLanguageId(event)}
                            value={langId}
                            getOptionValue={(option) => `${option.id}`}
                            getOptionLabel={(option) => `${option.name}`}
                        />
                    </div>
                    <div className={"col-12" + (isCustomUrl ? ' d-none':'')}>
                        <label htmlFor="specialFilterId" className="form-label">Filter Type <span className="text-danger">*</span></label>
                        <Select
                            classNamePrefix="form-select-search"
                            options={specialFilter}
                            onChange={(event) => onChangeFilterTypeId(event)}
                            value={specialFilterId}
                            getOptionValue={(option) => `${option.id}`}
                            getOptionLabel={(option) => `${option.name}`}
                        />
                    </div>
                    <div className={"col-12" + (isCustomUrl || specialFilterId?.id !== Utils.ADS_NAMING_SPECIAL_FILTER_BG_ZONE ? ' d-none':'')}>
                        <label htmlFor="zoneProject" className="form-label">Zone Project <span className="text-danger">*</span></label>
                        <Select
                            classNamePrefix="form-select-search"
                            options={projectType}
                            onChange={(event) => onChangeProjectTypeId(event)}
                            value={projectTypeId}
                            getOptionValue={(option) => `${option.id}`}
                            getOptionLabel={(option) => `${option.name}`}
                        />
                    </div>
                    <div className={"col-12" + (isCustomUrl || (specialFilterId?.id !== Utils.ADS_NAMING_SPECIAL_FILTER_BG_ZONE && specialFilterId?.id !== Utils.ADS_NAMING_SPECIAL_FILTER_COMBINE_ZONE) ? ' d-none':'')}>
                        <label htmlFor="zoneStatus" className="form-label">Zone Status <span className="text-danger">*</span></label>
                        <Select
                            classNamePrefix="form-select-search"
                            options={zoneStatus}
                            onChange={(event) => onChangeZoneStatusId(event)}
                            value={zoneStatusId}
                            getOptionValue={(option) => `${option.id}`}
                            getOptionLabel={(option) => `${option.name}`}
                        />
                    </div>
                    <div className={"col-12" + (isCustomUrl || specialFilterId?.id !== Utils.ADS_NAMING_SPECIAL_FILTER_BG_ZONE ? ' d-none':'')}>
                        <label htmlFor="bgZone" className="form-label">BG Zone <span className="text-danger">*</span></label>
                        <Select
                            isDisabled={!bgZone}
                            placeholder={bgZonePlaceholder}
                            classNamePrefix="form-select-search"
                            options={bgZone}
                            onChange={(event) => onChangeBGZoneId(event)}
                            value={bgZoneId}
                            getOptionValue={(option) => `${option.zone_slug}`}
                            getOptionLabel={(option) => `${option.zone_name} - ${option.zone_slug}`}
                        />
                    </div>
                    <div className={"col-12" + (isCustomUrl || specialFilterId?.id !== Utils.ADS_NAMING_SPECIAL_FILTER_COMBINE_ZONE ? ' d-none':'')}>
                        <label htmlFor="combineZone" className="form-label">Combine Zone <span className="text-danger">*</span></label>
                        <Select
                            isDisabled={!combineZone}
                            placeholder={combineZonePlaceholder}
                            classNamePrefix="form-select-search"
                            options={combineZone}
                            onChange={(event) => onChangeCombineZoneId(event)}
                            value={combineZoneId}
                            getOptionValue={(option) => `${option.zone_slug}`}
                            getOptionLabel={(option) => `${option.zone_name} - ${option.zone_slug}`}
                        />
                    </div>
                    <div className={"col-12" + (isCustomUrl || specialFilterId?.id !== Utils.ADS_NAMING_SPECIAL_FILTER_EVENT_REMINDER ? ' d-none':'')}>
                        <label htmlFor="eventDate" className="form-label">Event Date <span className="text-danger">*</span></label>
                        <DatePicker
                            selected={eventDate}
                            onChange={(date) => onChangeEventDate(date)}
                            dateFormat="yyyy-MM-dd"
                            wrapperClassName="w-100"
                            className="form-control" />
                    </div>
                    <div className={"col-12" + (isCustomUrl || specialFilterId?.id !== Utils.ADS_NAMING_SPECIAL_FILTER_EVENT_REMINDER ? ' d-none':'')}>
                        <label htmlFor="eventReminder" className="form-label">Event Reminder <span className="text-danger">*</span></label>
                        <Select
                            isDisabled={!eventReminder || !eventDate}
                            placeholder={eventReminderPlaceholder}
                            classNamePrefix="form-select-search"
                            options={eventReminder}
                            onChange={(event) => onChangeEventReminderId(event)}
                            value={eventReminderId}
                            getOptionValue={(option) => `${option.event_slug}`}
                            getOptionLabel={(option) => `${option.event_title} - ${option.event_slug}`}
                        />
                    </div>
                    <div className={"col-12" + (isCustomUrl || specialFilterId?.id !== Utils.ADS_NAMING_SPECIAL_FILTER_STATIC_PAGE ? ' d-none':'')}>
                        <label htmlFor="eventReminder" className="form-label">Static Page <span className="text-danger">*</span></label>
                        <Select
                            isDisabled={!staticPage}
                            placeholder={staticPagePlaceholder}
                            classNamePrefix="form-select-search"
                            options={staticPage}
                            onChange={(event) => onChangeStaticPageId(event)}
                            value={staticPageId}
                            getOptionValue={(option) => `${option.web_page}`}
                            getOptionLabel={(option) => `${option.web_page}`}
                        />
                    </div>
                    <div className="col-12">
                        <label htmlFor="eventReminder" className="form-label">Slug <span className="text-danger">*</span></label>
                        <input className="form-control" type="text" id="slug" ref={refSlug} disabled={true} />
                    </div>
                </div>
            </div>
            <div className={"col-12" + (roles.permissionId === Utils.SUPER_ADMIN_ID ? '':' d-none')}>
                <label htmlFor="agencyx" className="form-label">Agency</label>
                {
                    agency === null || agency.length <= 0 ? (<p>ไม่พบข้อมูล</p>) :
                        agency.map((row, index) => {
                            let chkId = 'agencyCheck' + row.id;
                            return (
                                <div key={index} className="form-check ms-2">
                                    <input className="form-check-input" name="agencyIds[]" type="checkbox" value={row.id} id={chkId} />
                                    <label className="form-check-label" htmlFor={chkId}>
                                        {row.name} {row.isEncrypt ? <span className="badge bg-secondary small">encrypt</span>:''}
                                    </label>
                                </div>);
                        })
                }
            </div>

            <div className="col-12">
                <label htmlFor="statusx" className="form-label">สถานะ</label>
                <div className="form-check form-switch">
                    <input className="form-check-input" type="checkbox" name="statusChecked" id="status" defaultChecked={true} />
                    <label className="form-check-label" htmlFor="status"></label>
                </div>
            </div>
            <div className="col-12">
                <button type="button" className="btn btn-primary" onClick={onCreate} disabled={isLoading}><span
                    className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isLoading ? btnTextLoading : btnTextDefault}</button>
                <NavLink className="btn btn-sm btn-light ms-2" to='/campaignTemplate'><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                <Toaster position="bottom-right" />
            </div>
        </>
    );
} 